<template>
  <div
    class="cbg-white-container theme--light v-card border-card input-container"
  >
    <CCol sm="12">
      <CRow>
        <CCol sm="6" md="3" class="form-group search-div">
          <label for>Search</label>
          <div class="col-sm-12 p-0 search-div position-relative">
            <input
              v-model="search"
              type="text"
              class="form-control"
              placeholder="Doctor/Patient Name"
              @input="throttledMethod"
            />
            <!-- <div class="search-svg">
              <searchSVG />
            </div>-->
            <div
              v-if="search !== ''"
              class="search-svg position-absolute"
              @click="clearSearch()"
            >
              <crossSVG />
            </div>
          </div>
        </CCol>
        <CCol sm="6" md="3" class="datepicker pos-r">
          <label for class="d-block-mob">Date Range</label>
          <datepicker
            v-model="dateRange"
            @input="dateChange()"
            :model-config="datePickerConfig"
            :max-date="new Date()"
            is-range
            :masks="{ input: 'DD-MM-YYYY' }"
            ref="datepicker"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control position-relative"
                placeholder="DD/MM/YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetActiveDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </CCol>
        <CCol sm="6" md="3">
          <div class="position-relative">
            <CSelect
              label="Filter by status"
              @update:value="udpateStatus"
              :options="statusOptions"
              v-model="status"
            />
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </CCol>
        <CCol sm="3">
          <label class="col-sm-12 mb-0 d-none-mob1"></label>
          <v-btn
            class="btn btn-primary"
            @click="downloadCsv()"
            :disabled="exportLoading"
            >{{ exportLoading ? "Exporting..." : "Export" }}</v-btn
          >
        </CCol>
      </CRow>
    </CCol>
    <CCol sm="12" class="overflow-auto">
      <table class="table userlistTable table-width small-table-width">
        <thead>
          <tr class="table-success">
            <th scope="col">Patient name</th>
            <th scope="col">Doctor name</th>
            <th scope="col">Ticket status</th>
            <th scope="col">OC refund status</th>
            <th scope="col">Date of grievance raised</th>
            <th scope="col">OC start time</th>
            <th scope="col">OC actual end time</th>
            <th scope="col">OC end time</th>
            <th scope="col">VC in minutes</th>

            <!-- <th scope="col">Utility Charges</th> -->
            <th scope="col">Action taken by</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <CCol v-if="refundData && refundData.length === 0" sm="12">
          <h2 class="text-center">No Data Found</h2>
        </CCol>
        <tbody v-if="refundData && refundData.length">
          <tr v-for="(report, i) in refundData" :key="i">
            <td class="text-capitalize">{{ report.patient_name }}</td>
            <td class="text-capitalize">Dr. {{ report.doctor_name }}</td>
            <td class="text-capitalize">
              <!-- {{ report.ticket_status }} -->
              <span
                class="badge badge-info"
                v-if="report.ticket_status == 'refunded'"
              >
                Refunded
              </span>
              <span
                class="badge badge-danger"
                v-else-if="report.ticket_status == 'rejected'"
              >
                Rejected
              </span>
              <span
                class="badge badge-warning"
                v-else-if="report.ticket_status == 'pending'"
              >
                Pending
              </span>
            </td>
            <td>
              {{ report.oc_refund_status }}
            </td>
            <td>
              {{
                dayJS(report.greivance_raised_time).format(
                  formats.date_time_format
                )
              }}
            </td>
            <td>
              {{
                report.oc_start_time
                  ? dayJS(report.oc_start_time).format(formats.date_time_format)
                  : "N/A"
              }}
            </td>
            <td>
              {{
                report.refund_request_date || report.oc_self_end_date
                  ? dayJS(
                      report.refund_request_date || report.oc_self_end_date
                    ).format(formats.date_time_format)
                  : "N/A"
              }}
            </td>
            <td>
              {{
                report.oc_end_time
                  ? dayJS(report.oc_end_time).format(formats.date_time_format)
                  : "N/A"
              }}
            </td>
            <td>
              {{
                report.video_call_time_used_in_minutes
                  ? report.video_call_time_used_in_minutes
                  : "N/A"
              }}
            </td>

            <!-- <td>&#8377; 27736</td> -->
            <td class="text-capitalize">
              {{ report.action_taken_by ? report.action_taken_by : "N/A" }}
            </td>
            <td class="action-div small-table-padding">
              <div>
                <CDropdown
                  color="link"
                  size="lg"
                  :caret="false"
                  class="dropdowndocbox"
                >
                  <template #toggler-content>
                    <verticalDotsSVG />
                  </template>
                  <CDropdownItem
                    v-if="report.ticket_status === 'pending'"
                    @click="openRefundProcess(report)"
                    >Resolve</CDropdownItem
                  >
                  <CDropdownItem
                    v-if="report.ticket_status === 'refunded'"
                    @click="openRefundProcess(report)"
                    >Grievance Accept Reason</CDropdownItem
                  >
                  <CDropdownItem
                    v-if="report.ticket_status === 'rejected'"
                    @click="openRefundProcess(report)"
                    >Grievance Reject Reason</CDropdownItem
                  >
                  <!-- <CDropdownItem>Process refund</CDropdownItem> -->
                </CDropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination
        class="pagination-block"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
      />
    </CCol>
    <refund-reason-modal
      v-if="refundProcess"
      :refundProcess="refundProcess"
      :selectedData="selectedData"
      @close="refundProcess = false"
      @reloadList="
        refundProcess = false;
        resetList();
      "
    />
  </div>
</template>
<script>
import debounce from "lodash/debounce";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import formats from "@/formats";
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const refundReasonModal = () =>
  import("@/views/dashboardNew/Accounts/refundReasonModal.vue");
export default {
  data() {
    return {
      exportLoading: false,
      dayJS,
      formats,
      refundReasonModal: false,
      refundProcess: false,
      currentPage: 1,
      search: "",
      statusOptions: [
        { value: "all", label: "All" },
        { value: "pending", label: "Pending" },
        { value: "refunded", label: "Refunded" },
        { value: "rejected", label: "Rejected" },
      ],
      status: "all",
      fetchWithdrawal: null,
      refundData: [],
      recordPerPage: 10,
      total: 0,
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dateRange: {
        start: "",
        end: "",
      },
      selectedCentre: null,
      selectedData: {},
    };
  },
  components: {
    Datepicker,
    "refund-reason-modal": refundReasonModal,
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("incomeSVG", "searchSVG", "verticalDotsSVG", "crossSVG"),
  },
  mounted() {
    this.getList();
  },
  methods: {
    openRefundProcess(data) {
      this.selectedData = {};
      this.selectedData = data;
      console.log("selectedData", this.selectedData);
      this.refundProcess = true;
    },
    getList() {
      let params = {
        ticket_status: this.status,
        greivance_type: "refund",
        records_per_page: this.recordPerPage,
        page: this.currentPage,
        start_date: this.dateRange.start
          ? this.dateRange.start.toISOString()
          : "",
        end_date: this.dateRange.end ? this.dateRange.end.toISOString() : "",
        search: this.search ? this.search : "",
      };
      let url = `${config.BASE_URL}api/v2/admin/greivances`;
      this.$http.get(url, { params }).then((response) => {
        if (response.status) {
          if (response.body.data.list.length) {
            this.refundData = response.body.data.list;
          }
          this.total = response.body.data.count;
        }
      });
    },
    resetList() {
      this.currentPage = 1;
      this.refundData = [];
      this.getList();
    },
    // pagination method
    changePage(page) {
      this.currentPage = page.currentPage;
      this.refundData = [];
      this.getList();
    },
    udpateStatus(status) {
      this.status = status;
      this.resetList();
    },
    // serch input method
    throttledMethod: debounce(function (e) {
      this.resetList();
    }, 1000),
    clearSearch() {
      this.search = "";
      this.resetList();
    },
    dateChange() {
      this.resetList();
    },
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.resetList();
    },
    downloadCsv() {
      this.exportLoading = true;
      let url = `${config.BASE_URL}api/v2/admin/greivances/export`;
      let params = {
        ticket_status: this.status,
        greivance_type: "refund",
        start_date: this.dateRange.start
          ? this.dateRange.start.toISOString()
          : "",
        end_date: this.dateRange.end ? this.dateRange.end.toISOString() : "",
        search: this.search ? this.search : "",
      };

      this.$http
        .get(url, { params })
        .then((res) => {
          if (res.body.status) {
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(
              new Blob(["\ufeff", res.body.data.csv_string])
            );
            downloadLink.download = res.body.data.csv_name;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
  },
};
</script>
